import { useEffect, useState, useCallback } from 'react';
import StorageManager from './StorageManager';

const storage = new StorageManager();

const useStorageSubscribe = (callback) => {
  useEffect(() => {
    if (!storage.isAvailable) return;

    window.addEventListener('storage', callback);

    return () => {
      window.removeEventListener('storage', callback);
    };
  }, [callback]);
};

export const useLocalStorage = (key, initialValue = null) => {
  const [store, setStore] = useState(() => {
    const item = storage.getItem(key);
    return item ? JSON.parse(item) : initialValue;
  });

  const setState = useCallback(
    (value) => {
      try {
        const nextState = typeof value === 'function' ? value(store) : value;

        nextState === undefined || nextState === null
          ? storage.removeItem(key)
          : storage.setItem(key, nextState);

        setStore(nextState);
      } catch (e) {
        console.warn(e);
      }
    },
    [key, store]
  );

  useStorageSubscribe((evt) => {
    if (evt.key === key) {
      setStore(evt.newValue ? JSON.parse(evt.newValue) : null);
    }
  });

  useEffect(() => {
    if (storage.getItem(key) === null && initialValue !== null) {
      storage.setItem(key, initialValue);
    }
  }, [key, initialValue]);

  return [store, setState];
};
